import React from "react";
import AboutUs from "./AboutUs";
import Contact from "./Contact";
import Footer from "./Footer";

// components
import Header from "./Header";
import Hero from "./Hero";
import Project from "./Project";
import Service from "./Service";
import Skills from "./Skills";
import CustomCursor from "./CustomCursor/index";

const App = () => {
  return (
    <>
      {/* Custom Cursor */}
      <CustomCursor />
      {/* header */}
      <Header />
      {/* hero */}
      <Hero />
      {/* about us */}
      <AboutUs />
      {/* skills */}
      <Skills />
      {/* services */}
      {/* <Service /> */}
      {/* projects */}
      <Project />
      {/* contact */}
      <Contact />
      {/* footer */}
      <Footer />
    </>
  );
};

export default App;
